import { FC } from "react";

import { GenericReadonlyTemplateStyled } from "./generic-readonly.styled";

interface IGenericReadonlyProps {
  label: string;
  value: string;
}

export const GenericReadonly: FC<IGenericReadonlyProps> = ({
  value,
  label,
}) => {
  return (
    <GenericReadonlyTemplateStyled>
      <label className="GenericReadonlyTemplate-Label">{label}</label>
      <span className="GenericReadonlyTemplate-Value">{value}</span>
    </GenericReadonlyTemplateStyled>
  );
};
